import { render, staticRenderFns } from "./AggressorDetails.vue?vue&type=template&id=4d1eaf1d&"
import script from "./AggressorDetails.vue?vue&type=script&lang=js&"
export * from "./AggressorDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports